// extracted by mini-css-extract-plugin
module.exports = {"Grid":"ManualGrid_Grid__2CpoG"};